import { render } from "./PublishVideo.vue?vue&type=template&id=546ae37b"
import script from "./PublishVideo.vue?vue&type=script&lang=js"
export * from "./PublishVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__